import moment from "moment";
import ActivityPreviewLink from "PFApp/components/activity_commons/activity_preview_link";
import { Icon } from "PFComponents/icon";
import { Activity } from "PFTypes";

import css from "./content.module.scss";
import { Description } from "./description";

export type EventContentProps = {
  task: Activity;
};

const formatRange = (start: string, end: string, separator: string) =>
  start === end ? start : `${start}${separator}${end}`;

const getEventDateRange = (startDate?: string, endDate?: string) => ({
  day: formatRange(moment(startDate).format("D"), moment(endDate).format("D"), "-"),
  month: formatRange(moment(startDate).format("MMM"), moment(endDate).format("MMM"), " - ")
});

export const EventContent = ({ task }: EventContentProps) => {
  const metadata = task.metadata || {};
  const { day, month } = getEventDateRange(metadata.start_date, metadata.end_date);

  return (
    <div className={css.wrapper}>
      <ActivityPreviewLink activity={task} profile={task.profile} className={css.name}>
        <div className={css.rawRow}>
          <div className={css.event}>
            <div>{day}</div>
            <small>{month}</small>
          </div>
          <div className={css.marginColumn}>
            <div className={css.eventDescription}>
              <Description description={task.description} />
            </div>
            {metadata.location && (
              <div className={css.location}>
                <Icon name="location" size="sm" color="paletteWhite3" />
                {metadata.location}
              </div>
            )}
          </div>
        </div>
      </ActivityPreviewLink>
    </div>
  );
};
